import {useLoaderData} from "@remix-run/react";
import {theme} from "../../styles/theme.js";
import {decodeHtmlEntities} from "../../utils/text.js";
import TitleUnderlinedAnimated from "../TitleUnderlinedAnimated";
import {Text} from "../text";
import {CardType, TopContentWrapper} from "./styles.js";

function containsHTML(text) {
  return /<[a-z][\s\S]*>/i.test(text);
}

export const CardContent = ({type, title, designType}) => {
  const isDangerousHTML = containsHTML(title);
  const {translation} = useLoaderData();
  const partnership = translation?.partnership || "Partenariat";

  const _title = decodeHtmlEntities(title);

  return (
    <div>
      <TopContentWrapper>
        <CardType designType={designType}>
          {designType === "blue" ? partnership : type}
        </CardType>

        {/*<CardDate designType={designType}>{date}</CardDate>*/}
      </TopContentWrapper>
      <div style={{height: "auto", width: "100%", paddingBottom: 34}}>
        {designType === "blue-border" ? (
          <Text
            lineClamp={3}
            styles={{lineHeight: "1.5rem", width: "fit-content", textTransform: "none"}}
            type="textLarge"
            dangerouslySetInnerHTML={{
              __html: _title,
            }}
          />
        ) : isDangerousHTML ? (
          <div
            style={{color: designType === "blue" ? "white" : "black"}}
            dangerouslySetInnerHTML={{
              __html: _title,
            }}
          />
        ) : (
          <Text
            className="title"
            lineClamp="3"
            styles={{
              color:
                designType === "blue"
                  ? theme?.colors?.primaryWhite
                  : theme?.colors?.primaryBlue,
              lineHeight: "1.5rem",
            }}
            type="textLarge"
          >
            {_title}
          </Text>
        )}
      </div>
    </div>
  );
};
